
import { useEffect, useRef, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import { Helmet } from 'react-helmet';
import AssetTypeSearchModal from './AssetTypeSearchModal';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import AssetTypeDetail from './AssetTypeDetail';
import swal from "sweetalert";
import { toast } from 'react-toastify';

const AssetTypeList = ({history}) => {
    
    const assetTypeUrl      =   BACKOFFICE_BASE_URL + '/asset_type';
    
    const access_token      =   useSelector(state => state.auth.access_token);
    const permissions       =   useSelector(state => state.app.acl_info?.permissions || []);
    const searchAssetTypeModalRef   =   useRef(null);

    const [listingLoading, setListingLoading]           =   useState(false);
    const [assetTypeListing, setAssetTypeListing]       =   useState([]);
    const [listingMeta, setListingMeta]                 =   useState(null);
    const [assetTypeFilterForm, setAssetTypeFilterForm] =   useState({});
    const [formSearchedElems, setFormSearchedElems]     =   useState([]);
    const [minimizeTable, setMinimizeTable]             =   useState(false); 
    const [detailData, setDetailData]                   =   useState(null);
    const [assetTypeId, setAssetTypeId]                 =   useState(null);

    useEffect                 (()           => {
        loadListingTblData(1);
    }, [formSearchedElems]);

    // useEffect                 (()           => {
    //     setPermissions(permissionsFromStore.length > 0 ? permissionsFromStore : []);
    // }, [permissionsFromStore]);

    const searchModalHandle      =    ()    => {
        if (searchAssetTypeModalRef.current) {
            searchAssetTypeModalRef.current.initModalHandler()
        }
    }
    const addEditModalHandle         =    (id = null)   => {
        if(id) {
            history.push('/asset_type_add?asset_type_id=' + id);
        }else {
            history.push('/asset_type_add');
        }
    }
    const detailModalHandle      =    (id)   => {
        setMinimizeTable(true);
        setAssetTypeId(id);
    }

    const loadListingTblData = (page = 1) => {
        setListingLoading(true);
        const params = { page: page, per_page: 25, ...assetTypeFilterForm };
        HttpAPICall.withAthorization('GET', assetTypeUrl + '/list', access_token, params, {}, (resp) => {
            const respData = resp.data;
            setAssetTypeListing(respData.data);
            setListingMeta({
                'from'          :   respData.from, 
                'to'            :   respData.to, 
                'total'         :   respData.total, 
                'last_page'     :   respData.last_page, 
                'per_page'      :   respData.per_page, 
                'current_page'  :   respData.current_page
            });
        }).then(() => setListingLoading(false));
    };
    
    const submitSearchForm = (searchedElems, assetTypeSearchForm) => {
        setFormSearchedElems(searchedElems);
        setAssetTypeFilterForm(assetTypeSearchForm);
    };

    const assetTypeSearchClear = () => {
        setFormSearchedElems([]);
        setAssetTypeFilterForm({});
        searchAssetTypeModalRef.current.clearSearchForm()
    };

    const deleteAssetType   =   (id)  =>  {
        swal({
            title: "Delete",
            text: "Are you sure want to delete this permanently?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        })
        .then(willDelete => {
            if (willDelete) {
                // HttpAPICall.withAthorization('DELETE', assetTypeUrl + '/delete/' + id, access_token,{},{},(resp) => {
                //     toast.success(resp.data.msg, {position: toast.POSITION.TOP_RIGHT});
                //     loadListingTblData(1)
                // });
            }
        });
    }

    const closeViewDetails  =   ()  =>  {
        setMinimizeTable(false);
        setAssetTypeId(null);
        setDetailData(null);
    }
    const assetTypeDetailData   =   (data)  => {
        setDetailData(data)
    }

    const assetTypeJsx = () => {
        return (
            <>
            <div className="page_title row m0">
                <div className={minimizeTable ? "col-3" : "col-12"}>
                    <h3>Asset Type List</h3>
                    <div className="text-end mt15">
                        {
                        (!minimizeTable) 
                        ?
                        <>
                        {
                            permissions.includes('asset_type_add') &&
                            <button type="button" className="btn btn-primary" onClick={() => addEditModalHandle(null)}>New</button>
                        }
                            <button type="button" className="btn btn-secondary" onClick={searchModalHandle} disabled={listingLoading}>
                                <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                            </button>
                        </>
                        : null
                        }
                    </div>
                </div>
            {
            minimizeTable
                ? (
                    <div className="col-9 tap_border_left">
                        <h3>Asset Type :  {detailData?.asset_type_name}</h3>
                        <div className="text-end mt15">
                            <button type="button" className="btn btn-secondary" onClick={closeViewDetails}>
                                <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                            </button>
                        </div>
                    </div>
                )
                : null
            }
            </div>

            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className={['pageTbl', minimizeTable ? 'col-3' : 'col-12'].join(' ')} >{assetTypeListingJsx()}</div>
                    {
                        minimizeTable 
                        ? <div className="col-9 pr4 pl4"><div className="bg-white p-2" style={{ height: "100%" }}><AssetTypeDetail assetTypeId={assetTypeId} assetTypeDetailData={assetTypeDetailData}/></div></div> 
                        : null
                    }
                </div>
            </div>
            </>
        );
    };
    const assetTypeListingJsx = () => {
        return (
            <>
                {
                    !minimizeTable && <DisplaySearchCriteria searchedElems={formSearchedElems} onClearFilter={assetTypeSearchClear} />
                }
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr className='text-center'>
                            {
                                minimizeTable 
                                ?
                                <th scope="col" style={{ width: "19%" }}>Asset Type Name</th>
                                :
                                <>
                                    <th scope="col" style={{ width: "5%" }}>S.No</th>
                                    <th scope="col" style={{ width: "19%" }}>Asset Type Name</th>
                                    <th scope="col" style={{ width: "26%" }}>Attributes Applicable</th>
                                    <th scope="col" style={{ width: "20%" }}>Odo Meter Applicable</th>
                                    <th scope="col" style={{ width: "25%" }}>Sections</th>
                                    <th scope="col" style={{ width: "5%" }}>Action</th>
                                </>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {listingLoading
                            ? (<tr><td colSpan="6"><Loader /></td></tr>)
                            : (assetTypeListing && assetTypeListing.length > 0
                                ? (assetTypeListing.map((item, index) => (
                                    <tr key={index}>
                                        {
                                            minimizeTable 
                                            ?
                                            <td><Link onClick={() => detailModalHandle(item.id)} >{item.asset_type_name}</Link></td>
                                            :
                                            <>
                                                <td className='text-center'>{listingMeta ? listingMeta.from + index : index}</td>
                                                <td><Link onClick={() => detailModalHandle(item.id)} >{item.asset_type_name}</Link></td>
                                                <td>
                                                    <ul>
                                                        {item.attributes.map(att => (<li>{att.name} : <b>{att.value == 'yes' ? <span className='text-success'>Yes</span> : 'No'}</b></li>))}
                                                    </ul>
                                                </td>
                                                <td>
                                                    <ul>
                                                        {item.odo_meters.map(om => (<li>{om.label}</li>))}
                                                    </ul>
                                                </td>
                                                <td>
                                                    <ol>
                                                    {item.sections?.map(s => (<li>{s.component}</li>))}
                                                    </ol>
                                                </td>
                                                <td className='text-center'>
                                                    <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                    { permissions.includes('asset_type_edit') &&
                                                        <li onClick={() => addEditModalHandle(item.id)}><Link className="dropdown-item" role="button">Edit</Link></li>
                                                    }
                                                    {/* { permissions.includes('asset_type_delete') &&
                                                        <li onClick={() => deleteAssetType(item.id)}><Link className="dropdown-item" role="button">Delete</Link></li>
                                                    } */}
                                                    </ul>
                                                </td>
                                            </>
                                        }
                                    </tr>
                                )))
                                : (<tr><td colSpan="5" className="text-center">No Records</td></tr>))
                        }
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={listingMeta}
                    onPageChange={(e) => loadListingTblData(e.selected + 1)}
                />
            </>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Asset Type Listing</title></Helmet>
            {assetTypeJsx()}
            <AssetTypeSearchModal ref={searchAssetTypeModalRef} submitSearchFormProp={submitSearchForm}/>
        </ApplicationLayout>
    );
};

export default AssetTypeList;



